import React, { useEffect, useState } from "react";
import { Globe2, ChevronDown } from "lucide-react";
import api from "../lib/api";

const META = { SGD: { flag: "🇸🇬", name: "Singapore" }, MYR: { flag: "🇲🇾", name: "Malaysia" }, THB: { flag: "🇹🇭", name: "Thailand" } };

/* Recharge guide for overseas players (SGD/MYR/THB), translated into the app language on the server */
export function LocalPayHint({ currency, lang }) {
  const [text, setText] = useState("");
  const [open, setOpen] = useState(true);
  useEffect(() => {
    if (!currency || !META[currency]) { setText(""); return; }
    api.get("/pay-hint", { params: { currency, lang } }).then((r) => setText(r.data?.text || "")).catch(() => setText(""));
  }, [currency, lang]);
  if (!text) return null;
  const m = META[currency];
  return (
    <div className="rounded-2xl p-3.5 text-white" style={{ background: "linear-gradient(120deg,#0f766e,#1e3a8a)" }} data-testid="local-pay-hint">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 text-left" data-testid="local-pay-hint-toggle">
        <Globe2 className="w-4 h-4 text-amber-300 shrink-0" />
        <span className="text-sm font-bold flex-1">{m.flag} {m.name} → ₹ Recharge</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="text-xs text-emerald-50 mt-2 leading-relaxed whitespace-pre-line" data-testid="local-pay-hint-text">{text}</p>}
    </div>
  );
}
